import { MouseEvent } from 'react';
import clsx from 'clsx';

import classes from './Radio.module.scss';
import { RecordObject } from 'src/models';

interface Props {
  isChecked?: boolean;
  value?: string;
  label?: string;
  onClick: (e: MouseEvent) => void;
  style?: RecordObject<string>;
}

// new-ui
export function Radio({ isChecked, value, label, onClick, style }: Props) {
  return (
    <div data-testid='container' className={clsx(classes.container, 'row nowrap a-center')} onClick={onClick}>
      <input readOnly data-testid='input' type='radio' value={value} checked={isChecked} />
      {label && <label style={style}>{label}</label>}
    </div>
  );
}
